import { useMemo } from 'react'

type FieldConfig<T extends string = string> = {
  editableFields?: T[]
  hiddenFields?: T[]
}

export function useConditionalFields<T extends string>(config: FieldConfig<T>) {
  const { editableFields = [], hiddenFields = [] } = config

  const isEditable = useMemo(() => (field: T) => editableFields.includes(field), [editableFields])
  const isHidden = useMemo(() => (field: T) => hiddenFields.includes(field), [hiddenFields])

  return {
    isEditable,
    isHidden,
    editableFields,
    hiddenFields,
  }
}
